import { ArrowLeft, Edit3 } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoleInfoBlock } from './components/RoleInfoBlock';
import { RolePermissionsBlock } from './components/RolePermissionsBlock';
import { useRolesDetail } from './hooks/useRolesDetail';

export function RolesDetailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const { role, isLoading, error } = useRolesDetail(id);

  if (error) {
    return (
      <div className="rounded-md border border-rose-100 bg-white p-3 text-sm text-rose-700">
        Không thể tải vai trò: {error}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 rounded-md border border-slate-100 bg-white p-3 shadow-sm md:flex-row md:items-center md:justify-between">
        <button
          type="button"
          onClick={() => navigate('?tab=roles')}
          className="flex h-10 items-center justify-center gap-2 rounded-md border border-slate-100 bg-white px-3 text-sm font-semibold text-slate-700 md:w-auto"
        >
          <ArrowLeft className="h-4 w-4" />
          Quay lại
        </button>
        <button
          type="button"
          onClick={() => navigate(`?tab=roles-edit&id=${id}`)}
          className="flex h-10 items-center justify-center gap-2 rounded-md bg-emerald-600 px-3 text-sm font-semibold text-white md:w-auto"
        >
          <Edit3 className="h-4 w-4" />
          Sửa vai trò
        </button>
      </div>
      <RoleInfoBlock role={role} isLoading={isLoading} />
      <RolePermissionsBlock permissions={role?.permissions || []} isLoading={isLoading} />
    </div>
  );
}
